<template>
  <div class="animated-icon">
    <div class="background-outline"></div>
    <div class="spinning-outline"></div>
  </div>
</template>

<script setup></script>

<style scoped>
.animated-icon {
  width: 1.75rem;
  height: 1.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 0.125rem;
}

.background-outline {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 3px solid var(--font-dimmest);
  outline-offset: -2px; 
  border-radius: 50%;
}

.spinning-outline {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 3px solid transparent;
  border-top-color: var(--border-dark);
  border-radius: 50%;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
